import { normalizeCardNumberInput } from '../../lib/formatter';

export const CARD_NUMBER_REQUIRED_ERROR = 'Номер карты обязателен к заполнению';
export const CARD_NUMBER_LENGTH_ERROR = 'Номер карты должен содержать от 16 до 19 цифр';

const CARD_NUMBER_PATTERN = /^\d{16,19}$/;

interface ValidateCardNumberOptions {
    required?: boolean;
}

export const validateCardNumber = (value?: string | null, { required = false }: ValidateCardNumberOptions = {}) => {
    const normalizedCardNumber = normalizeCardNumberInput(value ?? '');

    if (!normalizedCardNumber) {
        return required ? CARD_NUMBER_REQUIRED_ERROR : undefined;
    }

    if (!CARD_NUMBER_PATTERN.test(normalizedCardNumber)) {
        return CARD_NUMBER_LENGTH_ERROR;
    }

    return undefined;
};

export const isValidCardNumber = (value?: string | null) => {
    return validateCardNumber(value) === undefined;
};
